import {
  Component,
  OnInit,
  AfterViewInit,
  AfterViewChecked,
  AfterContentInit,
} from "@angular/core";
import { ObtenerUsuarioPorCargo, RegistroBitacoraInput } from '../entidades/entidades';
import { RegistroBitacoraService } from "app/servicios/registro-bitacora.service";
import { Router, Routes } from '@angular/router';
import { RouteInfo } from "../entidades/entidades";
import { AuthenticationService } from "../servicios/authentication.service";
import { ObtenerUsuarioPorCargoService } from "../servicios/obtener-usuario-por-cargo.service";
import { CatModulosService } from "app/servicios/cat-modulos.service";
import { PrivilegiosService } from "app/servicios/privilegios.service";
import Utils from "../shared/utilerias/utils";
import { HostListener } from '@angular/core';
//Menu Items
export const ROUTES: RouteInfo[] = [
  {
    path: "/atencion",
    title: "Atención a Usuarios",
    type: "padre",
    collapse: "atencion",
    icontype: "nc-icon nc-single-02",
    children: [
      {
        path: "estadocuenta",
        title: "Estado de Adeudos",
        ab: "EA",
        type: "hijo",
      },
      {
        path: "ventanilla",
        title: "Ventanilla",
        ab: "V",
        type: "hijo",
      },
      {
        path: "informacion",
        title: "Seguimiento del Trámite",
        ab: "ST",
        type: "hijo",
      },
      {
        path: "aguas-descuentos",
        title: "Descuentos",
        ab: "GV",
        type: "hijo",
      },
      {
        path: "OrdenDeTrabajo",
        title: "Ordenes De Trabajo",
        ab: "OT",
        type: "hijo",
      },
      {
        path: "Prorrateos",
        title: "Prorrateos",
        ab: "PR",
        type: "hijo",
      },
      {
        path: "cat-reportes",
        title: "Reportes",
        ab: "R",
        type: "hijo",
       },
      {
        path: "padron",
        title: "Padrón",
        ab: "P",
        type: "hijo",
      },
      //  No borrar este bloque de comentario ya que si se va crear a futuro
      {
       path: "reporte-atencion",
       title: "Reportes",
       ab: "R",
       type: "hijo",
      },
    ],
  },
  {
    path: "/medicionyfacturacion",
    title: "Micromedición",
    type: "padre",
    collapse: "medicionyfacturacion",
    icontype: "nc-icon nc-ruler-pencil",
    children: [
      {
        path: "genera-rutas",
        title: "Asignación",
        ab: "A",
        type: "hijo",
      },
      {
        path: "captura-lecturas",
        title: "Captura",
        ab: "C",
        type: "hijo",
      },
   
      // {
      //   path: "correcion-lecturas",
      //   title: "Corrección de Periodos",
      //   ab: "CP",
      //   type: "hijo",
      // },
      {
        path: "medidores",
        title: "Medidores",
        ab: "MD",
        type: "hijo",
      },

      // No borrar este bloque de comentario ya que si se va crear a futuro
      {
       path: "reporte-atencion",
       title: "Reportes",
       ab: "R",
       type: "hijo",
      },

    ],
  },
  {
    path: "/liquidacion",
    title: "Facturación y cobranza",
    type: "padre",
    collapse: "operacion",
    icontype: "nc-icon nc-credit-card",
    children: [
      {
        path: "gestor-convenios",
        title: "Gestor De Convenios",
        ab: "GC",
        type: "hijo",
      }, 
      {
        path: "convenios",
        title: "Convenios",
        ab: "C",
        type: "hijo",
      }, 
      // {
      //   path: "correcion-lecturas",
      //   title: "Ajustes",
      //   ab: "CP",
      //   type: "hijo",
      // },
      {
        path: "ejecucion-fiscal",
        title: "Notificación y Corte",
        ab: "E",
        type: "hijo",    
      },
      { path: "aguas-bloqueos", 
        title: "Bloqueo de Cuentas", 
        ab: "BC", 
        type: "hijo" 
      },
      {
        path: "estadocuentamasivo",
        title: "Estado de Cuenta Masivo",
        ab: "EC",
        type: "hijo",
      },
      {
        path: "prescripcion",
        title: "Prescripción",
        ab: "PRE",
        type: "hijo",
      },
      {
        path: "edicion-cargo",
        title: "Edición: Cargos y Consumos",
        ab: "EDC",
        type: "hijo",
      },      
      {
        path: "reportes-facturacion-cobranza",
        title: "Reportes",
        ab: "RP",
        type: "hijo",
      }, 
       //se comenta por que aun esta en desarrollo    
       { 
        path: "envio-masivo-recibo",
        title: "Envio masivo recibo",
        ab: "EMC",
        type: "hijo",
      },
     
    ],
  },
  /*{
    path: "/promociones",
    title: "Descuentos",
    type: "padre",
    collapse: "comercializacion",
    icontype: "nc-icon nc-air-baloon",
    children: [

      {
        path: "cat-descuentos",
        title: "Descuentos",
        ab: "D",
        type: "hijo",
      },
      
     
    ],
  },*/
  /*{
    path: "/fiscalizacion",
    title: "Fiscalización",
    type: "padre",
    collapse: "fiscalizacion",
    icontype: "nc-icon nc-bank",
    children: [
      
      //{ path: "aguas-bloqueos", title: "Bloqueo de Cuentas", ab: "BC", type: "hijo" },
      
    
     // {
     //   path: "ejecucion-fiscal",
     //   title: "Ejecución fiscal",
     //   ab: "E",
     //   type: "hijo",
      
     // },
      
    
     
    ],
  },*/



  {
    path: "/ingresos",
    title: "Tesoreria",
    type: "padre",
    collapse: "ingresos",
    icontype: "nc-icon nc-money-coins",
    children: [
      { path: "caja", title: "Caja", ab: "C", type: "hijo" },
      {
        path: "admin-caja",
        title: "Administración de Caja",
        ab: "A",
        type: "hijo",
      },
      {
        path: "facturacion",
        title: "Facturación",
        ab: "F",
        type: "hijo",
      },
      {
        path: "conciliacion",
        title: "Pagos En Banco",
        ab: "CN",
        type: "hijo",
      },
      {
        path: "datos-fiscales",
        title: "Datos Fiscales",
        ab: "D",
        type: "hijo",
      },
      //{
        //path: "cobros",
        //title: "Cobros",
        //ab: "CO",
        //type: "hijo",
      //},
      {
        path: "reportes",
        title: "Reportes Ingresos",
        ab: "RP",
        type: "hijo",
      },
    ],
  },
  {
    path: "/administracion",
    title: "Administración",
    type: "padre",
    collapse: "administracion",
    icontype: "nc-icon nc-chart-bar-32",
    children: [
  
      {
        path: "busca-bitacora-grid",
        title: "Bitácora",
        ab: "B",
        type: "hijo",
      },
      { 
        path: "catalogos", 
        title: "Catálogos",
        ab: "C", 
        type: "hijo" 
      },
       { 
         path: "permisos",
         title: "Seguridad",
         ab: "P",
         type: "hijo" 
      },
      {
        path: "reportes",
        title: "Reportes",
        ab: "RP",
        type: "hijo",
      },
       {
        path: "cat-descuentos",
        title: "Campañas",
        ab: "D",
        type: "hijo",
      },
      //{
      //  path: "prescripcion",
      //  title: "Prescripción",
      //  ab: "PRE",
      //  type: "hijo",
      //},
      //{
      //  path: "edicion-cargo",
      //  title: "Editar Cargo",
      //  ab: "EDC",
      //  type: "hijo",
      //}, 
      
    ],
  }

];


@Component({
  moduleId: module.id,
  selector: "sidebar-cmp",
  templateUrl: "sidebar.component.html",
})
export class SidebarComponent  {
  currentUser: any;
  depth: number = 0;

  usuario: any;
  public registroBitacora = new RegistroBitacoraInput();

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private obtenerUsuarioPorCargoService: ObtenerUsuarioPorCargoService,
    private catModulosService: CatModulosService,
    private registroBitacoraService: RegistroBitacoraService,
    private privilegiosService: PrivilegiosService,
    
  ) {}
  public menuItems: RouteInfo[] = [];
  isNotMobileMenu() {
    if (window.outerWidth > 991) {
      return false;
    }
    return true;
  }

  async ngOnInit() {

    if (localStorage.getItem('pageReloaded')) {
      var Token: string = JSON.parse(localStorage.getItem("currentUser")).token;
      var TokenOld: string = localStorage.getItem("tokenActivo");
      
      localStorage.removeItem("pageReloaded");
      localStorage.removeItem("tokenActivo");

      if(Token == TokenOld){
        await this.logout();
      }
    } else {
      // Establecer el indicador de recarga de página
      localStorage.setItem('pageReloaded', 'true');
      localStorage.setItem('tokenActivo', JSON.parse(localStorage.getItem("currentUser")).token);
    }
    
    // Detectar el cierre de la pestaña o navegador
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    
    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue;
    const modulos = await this.catModulosService
      .getCatModulosByUser()
      .toPromise();
     
      const privilegios = await this.privilegiosService
      .GetPrivilegiosByUser()
      .toPromise();

   
    this.menuItems = ROUTES.filter((x) =>
      this.isAllowedModule(x, modulos, privilegios)
    );
    /*console.log("sidebar usuario " + this.usuario);*/
    /*console.log("rutas", ROUTES);*/
  }

  ngOnDestroy(): void {
    // Limpiar el evento al destruir el componente
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  private handleBeforeUnload(event: BeforeUnloadEvent): void {
    //this.router.navigate(["/login"]);
    // Realizar la solicitud para eliminar el token de la base de datos
    // Solo enviamos la señal cuando se está cerrando la pestaña o el navegador, no en recarga
    /*if (navigator.sendBeacon) {
      var Token: string = JSON.parse(localStorage.getItem("currentUser")).token;
      localStorage.removeItem("currentUser");

      const data = {
        Token: Token,
        username: 'nn',
        password: 'nn',
      };

      this.router.navigate(["/"]);

      // Aquí pones la URL de tu API que eliminará el token
      const url = `${Utils.getBaseUrlApiWeb()}/users/logout`;  // Modifica esta URL con tu API real

      navigator.sendBeacon(url, JSON.stringify(data));
    } else {
      console.warn('sendBeacon no está disponible en este navegador');
    }*/
  }
  isAllowedModule(itemRoute, modulo, privilegios) {
    if (modulo.filter((x) => x.path == itemRoute.path).length > 0)
      return (itemRoute.children = itemRoute.children.filter((x) =>
        this.isAllowedPrivilege(x, privilegios)
      ));

    return undefined;
  }

    isAllowedPrivilege(itemChildren, privilegios) {
     if ((privilegios.filter(x => x.path == itemChildren.path)).length > 0)
          return itemChildren;

        return undefined;
     }
  ngAfterViewInit() {}
  async logout() {
    if(localStorage.getItem("currentUser")){
      var Token: string = JSON.parse(localStorage.getItem("currentUser")).token;
      this.authenticationService.deleteLocalStorage();
         
      await   this.authenticationService.logout(Token);
    }else{
      this.authenticationService.deleteLocalStorage();
    }
    
      localStorage.removeItem("pageReloaded");
      localStorage.removeItem("tokenActivo");
      this.router.navigate(["/login"]);
      this.authenticationService.deleteLocalStorage();

    //this.registroBitacora.idUsuario = this.usuario.id;
    //this.registroBitacora.accion = "SALIÓ DEL SISTEMA";
    //const datRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();
    //se pone porque al agregar un privilegio y cerrar sesion no mostraba los nuevos privilegios (tony)
    /*this.router.navigate(['/']).then(() => {
      window.location.reload(); // Opcional si necesitas recargar completamente
    });*/
  }

  manuales()
  {
    this.router.navigateByUrl('componentes/manuales');
  }
}
